import type { NavPref, Preferences } from './preferences.interface';

export class NavPrefDefault implements Preferences  {
  isDarkMode = false;
  isStudiesTableMode = false;

  public navPref: NavPref[] = [{
    navItem: 1,
    pinned: true
  }, {
    navItem: 2,
    pinned: true
  }, {
    navItem: 3,
    pinned: false
  }, {
    navItem: 4,
    pinned: true
  }, {
    navItem: 5,
    pinned: true
  }, {
    navItem: 6,
    pinned: false
  }, {
    navItem: 7,
    pinned: true
  }, {
    navItem: 8,
    pinned: false
  }, {
    navItem: 9,
    pinned: false
  }, {
    navItem: 10,
    pinned: false
  }, {
    navItem: 11,
    pinned: false
  }, {
    navItem: 12,
    pinned: false
  },
  {
    navItem: 13,
    pinned: false
  },
  {
    navItem: 14,
    pinned: false
  },
  {
    navItem: 15,
    pinned: false
  }];
}
